// extracted by mini-css-extract-plugin
module.exports = {"departments":"cq-z","departmentHeading":"dq-z","departmentSection":"eq-z","departmentName":"fq-z","departmentLink":"gq-z","expandIcon":"hq-z"};